import Image from 'next/image';
import useDeviceDetect from 'react-scale/hooks/useDeviceDetect';

import { CTA, Section } from 'react-scale/components';

const GetStarted = () => {
  const { isMobile } = useDeviceDetect();

  return (
    <div className="mb-32 md:mb-40 lg:mb-[200px]">
      <Section bg="bg-neutral-800">
        <div className="flex text-center lg:text-left items-center lg:space-x-20 xl:space-x-[90px] space-x-0 mx-auto flex-col-reverse lg:flex-row">
          <Image
            loading="eager"
            quality={100}
            layout="intrinsic"
            src="/static/images/pages/open-datasets/oxford/full-cover.png"
            width={isMobile ? 257 : 325}
            height={isMobile ? 343 : 433}
            alt="oxford dataset cover"
          />
          <div className="space-y-10 md:space-y-8 flex-1 mb-20 lg:mb-0">
            <p className="tracking-[4px] text-[#AAD2FF] uppercase">dev kit</p>
            <p className="text-[32px] leading-[44px] md:text-4xl lg:text-5xl xl:leading-[52px] font-aeonik">
              Get Started with Oxford&nbsp;Dataset
            </p>
            <div>
              <p className="text-neutral-200 md:text-base lg:text-lg text-lg leading-8">
                Read the full{' '}
                <a
                  className="text-scale-lightskyblue underline"
                  href="https://openreview.net/forum?id=udVUN__gFO"
                >
                  Research Paper
                </a>
                . If you use the dataset, please make sure to cite our&nbsp;paper.
              </p>
            </div>
            <div className="max-w-max lg:max-w-none mx-auto">
              <CTA
                cta={{
                  buttons: [
                    {
                      text: 'Download Dataset',
                      href: '#download',
                      type: 'primary',
                      borderColor: '#AAD2FF'
                    },
                    {
                      text: 'Get Started: Colab Notebook',
                      href: 'https://colab.research.google.com/drive/14TQnM9ThuxKVCxQ21Gi_Yoyo4J0MqJ36',
                      type: 'secondary',
                      borderColor: '#E5E5E5'
                    }
                  ]
                }}
              />
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
};

export default GetStarted;
